import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ztdnlvzm9: FaireBrandEntity = {
  token: "b_4ztdnlvzm9",
  type: "brand",
  name: "Eurographics Puzzles USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c5b37c84b5a7323655ee422b49736588d17da0997aa921cdf44a9b7da1d43ef.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ae114ab456629b3c49f242d7d3989bec26b40e62acf5cef608511f99f7c5112f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7c5b37c84b5a7323655ee422b49736588d17da0997aa921cdf44a9b7da1d43ef.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ae114ab456629b3c49f242d7d3989bec26b40e62acf5cef608511f99f7c5112f.jpeg",
  location: "Montreal, QC, CAN",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "Eurographics is committed to offering jigsaw puzzles of exceptional quality and a wide variety of images and piece counts.  Our puzzles are made with premium blue-board, using razor sharp tools for the cleanest of cuts.  \n\nOur unique line includes packaging made of shaped tins, insulated lunch bags, and the highest qualify of cardboard packaging.  We offer puzzle advent calendars, 3D houses made with actual jigsaw puzzles, the only of its kind in the industry, and regular jigsaw puzzles with piece counts ranging from 24 - 5,000!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.070Z",
    importedBy: "entity-db-cli",
  },
};
